<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>
        <template v-slot:card-body>
            <card-grid
                ref="grid"
                :key="cardGridKey"
                :is-search="false"
                :columnDefs="columnDefs"
                :fetch-callback="fetchCallback"
                :pagination="true"
                :pagination-page-size="limit"
                :cache-block-size="limit"
                :is-auto-width="true"
                :font-size="tabWidget.settings.table_font_size"
            ></card-grid>
        </template>
        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
import API from '../../../../api';
import CardGrid from '../../../generic/card-grid/card-grid.vue';
import CardGridItem from '../common/card-grid-item.vue';
import { DASHBOARD_CANCELLATION_GRID_ENDPOINT } from '../../../../endpoints';
import { getWidgetGridRowsNumber } from '../helpers';
import GuestCellRenderer from '../common/guest-cell-renderer.vue';
import { mapGetters } from 'vuex';
import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';

export default {
    name: 'CancellationsTableCardGridItem',
    mixins: [cardGridItemBaseMixin],
    components: {
        CardGrid,
        CardGridItem,
        TabWidgetSettingsModalForm,
        guestCellRenderer: GuestCellRenderer,
    },
    computed: {
        ...mapGetters('header', ['userPermissions']),
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(DASHBOARD_CANCELLATION_GRID_ENDPOINT(), {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
        tabWidgetSettingsInitialValues() {
            return {
                settings: {
                    name: this.tabWidget.settings.name || this.defaultName,
                    table_font_size: this.tabWidget.settings.table_font_size || this.defaultWidgetFontSize,
                },
            };
        },
    },
    data() {
        return {
            columnDefs: [
                {
                    field: 'booking_method_name',
                    headerName: '',
                    maxWidth: 60,
                    sortable: false,
                    cellRenderer: ({ data }) =>
                        data &&
                        `<img src="${data.booking_method_icon_url}" title="${data.display_booking_method_name}"/>`,
                },
                {
                    field: 'cancel_time',
                    headerName: 'Cancelled',
                    type: 'dateTimeColumn',
                    // minWidth: 190,
                    sort: 'desc',
                },
                {
                    field: 'user',
                    headerName: 'Guest',
                    headerClass: 'guest-name-status-column',
                    cellRenderer: 'guestCellRenderer',
                    cellRendererParams: {
                        getReservation({ data }) {
                            return data;
                        },
                    },
                    minWidth: 240,
                    autoWidthExclude: true
                },
                {
                    field: 'id',
                    headerName: 'Invoice #',
                    cellRenderer: ({ data }) => {
                        return this.userPermissions?.can_view_invoices
                            ? `<a href="/app/reservation/edit/invoice/${data.id}">#${data.id}</a>`
                            : `#${data.id}`;
                    },
                    // minWidth: 130,
                },
                {
                    field: 'from_date',
                    headerName: 'Start Date',
                    type: 'dateColumn',
                    // minWidth: 150,
                },
                {
                    field: 'to_date',
                    headerName: 'End Date',
                    type: 'dateColumn',
                    // minWidth: 150,
                },
            ],
            offset: 0,
            limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
            sort: 'id',
            desc: true,
            search: '',
        };
    },
    methods: {
        handleResized() {
            this.limit = getWidgetGridRowsNumber({ tabWidget: this.tabWidget });
            this.cardGridKey += 1;
        },
    },
};
</script>
